<template>
    <nav class="bread-crumbs" :aria-label="$snippet('breadcrumbs_aria_label', 'breadcrumbs')">
        <b-breadcrumb
            :items="crumbs"
        />
    </nav>
</template>

<script>
    import { BBreadcrumb } from 'bootstrap-vue';

    export default {
        name: 'bread-crumbs',

        components: { BBreadcrumb },

        props: {
            crumbs: {
                type: Array,
                default: () => ([]),
            },
        },
    };
</script>

<style lang="scss" scoped>
    ::v-deep {
        @import "~bootstrap/scss/breadcrumb";
    }

    a {
        color: primary-palette(2);
        font-weight: 300;

        &:hover {
            color: primary-palette(1);
            text-decoration: none;
        }
    }

    span {
        font-weight: bold;
    }
</style>
